import React from 'react';
import PropTypes from 'prop-types';
import PlatformReactMarkdown from 'lib/react-markdown';

const FinalScreen = ({ title, subtitle, paragraphs, primaryButtonText, onPrimary }) => {
  return (
    <div className="intake-step text-center">
      <h2 className="intake-title">{title}</h2>
      {subtitle && <h3 className="intake-subtitle">{subtitle}</h3>}
      {paragraphs && (
        <div className="intake-paragraphs">
          <PlatformReactMarkdown>{paragraphs.join('\n\n')}</PlatformReactMarkdown>
        </div>
      )}
      <div className="intake-actions">
        <button type="button" className="btn btn-lg btn-secondary px-4" onClick={onPrimary}>
          {primaryButtonText}
        </button>
      </div>
    </div>
  );
};

FinalScreen.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  paragraphs: PropTypes.arrayOf(PropTypes.string),
  primaryButtonText: PropTypes.string.isRequired,
  secondaryButtonText: PropTypes.string.isRequired,
  onPrimary: PropTypes.func.isRequired
};

export default FinalScreen;
